import { FormStatus } from 'entities/common';
import { omitKeyImmutable } from 'utils/object';

/** Шаги формы, для опубликованной формы отрисовываем третий этап */
export const FORM_STEPS: Record<
  Exclude<FormStatus, FormStatus.FINISHED>,
  number
> = {
  [FormStatus.DRAFT]: 0,
  [FormStatus.FILE_UPLOAD]: 1,
  [FormStatus.VALIDATION]: 2,
  [FormStatus.PUBLISHED]: 2,
};

/**
 * Отрисовываем все шаги, кроме published
 * */
export const STEPS_TO_RENDER = omitKeyImmutable(
  FORM_STEPS,
  FormStatus.PUBLISHED
);

/**
 * Мапим индекс к статусу
 * */
export const REVERSE_STEPPER: Record<
  number,
  Exclude<FormStatus, 'published'>
> = {
  0: FormStatus.DRAFT,
  1: FormStatus.FILE_UPLOAD,
  2: FormStatus.VALIDATION,
};
